'use client';
import { PageTitle } from '@/components/Layout/LeftPane/PageTitle';
import { OrderCard } from '@/components/OrderCard';
import { Attendee, Order } from '@/types';
import Link from 'next/link';
import React, { useState } from 'react';
import homeStyles from '../../styles/Home.module.css';
import { useCSRFToken } from '../contextProvider';

interface TicketsFoundPageProps {
  orders: Order[];
  setCurrentPage: (page: 'ticketDetails') => void;
  handleOrderClick: (order: Order, attendeesList: Attendee[]) => void;
}
export const TicketsFoundPage: React.FC<TicketsFoundPageProps> = ({
  setCurrentPage,
  orders,
  handleOrderClick,
}) => {
  const csrfToken = useCSRFToken();
  const [error, setError] = useState<string | null>(null);
  const fetchAttendeeDetails = async (order: Order) => {
    const attendeesList: Attendee[] = [];
    handleOrderClick(order, order.attendeesData.attendeesList);
  };
  const ticketFoundTitle = orders?.length > 1 ? 'Tickets found' : 'Ticket found';

  return (
    <>
      {' '}
      <PageTitle pageTitle={ticketFoundTitle} />
      <div>
        <div className={homeStyles.ordersWrapperDiv}>
          {orders?.map((order: Order) => (
            <>
              <Link
                key={order.orderId}
                href=""
                passHref
                onClick={() => fetchAttendeeDetails(order)}
                className={homeStyles.orderCardLink}
              >
                <OrderCard key={order.orderId} order={order} />
              </Link>
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default TicketsFoundPage;
